import { createApiEffect } from '@/features/api/common/create-api-effect'
import { StudentByIdResponse } from '@/features/api/student/types'

export const getStudentByIdFx = createApiEffect<string, StudentByIdResponse>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/user-app/student/${id}/`,
  }),
})
